<object *ngIf="pdf" [data]="pdf|urlSanitizer" ></object>
<div class="div-error-message" *ngIf="errorMessage">{{errorMessage}}</div>
<div class="div-footer">
  <button mat-raised-button color="primary" (click)="onClickClose()">Schließen</button>
</div>

